import { useCallback } from "react";

import { useActiveSubscription } from "routes/data-routes/billing-data/active-subscription";
import { ChargebeePortalSection, useChargebee } from "providers/ChargebeeProvider";
import scraperApi from "api";


export function useChargebeePortals() {

  const { activeSubscription } = useActiveSubscription();
  const { chargebeeInstance, chargebeePortalSections } = useChargebee();


  const isChargebeeReady = !!chargebeeInstance && !!chargebeePortalSections;

  const openChargebeePortal = useCallback(
    (sectionType: ChargebeePortalSection, options?: any) => {
      if (!chargebeeInstance || !chargebeePortalSections) return;

      // init the portal session with token and secret from the backend
      chargebeeInstance.setPortalSession(scraperApi.subscription.billingSessions);

      chargebeeInstance
        .createChargebeePortal()
        .openSection(
          {
            params: { subscriptionId: activeSubscription?.chargebeeSubscriptionId },
            sectionType: chargebeePortalSections[sectionType]
          },
          { ...options }
        );
    },
    [ chargebeeInstance, chargebeePortalSections, activeSubscription ]
  );

  const closeAllChargebeePortals = useCallback(() => {
    chargebeeInstance.closeAll();
  }, [ chargebeeInstance ]);

  const generatePayNowLink = useCallback(async () => {
    return (await scraperApi.subscription.payNowLink())?.url;
  }, []);


  return {
    isChargebeeReady,
    openChargebeePortal,
    closeAllChargebeePortals,
    generatePayNowLink
  };
}
